/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ActionApi } from './ActionApi.types.tsx';

export const installCdm =
	(): ActionApi =>
	async ({ setState, getState }) => {
		// TODO: Implement the actual CDM instantiation logic here
		// submitAsyncCdmBundleInstantiationTask
		// useCmdbAsyncBundleInstantiation

		const state = getState();

		// Fake CDM instantiation task
		setState({
			...state,
			cdm: {
				...state.cdm,
				tasks: [...state.cdm.tasks, 'instantiateBundle'],
			},
		});

		// Wait 2 seconds
		await new Promise((resolve) => setTimeout(resolve, 2000));

		// Remove the task and add mock instantiation
		setState({
			...getState(),
			cdm: {
				instantiations: [
					{ instantiationId: 'test-instantiation-id', bundleId: 'test-bundle-id', schemas: [] },
				],
				tasks: [],
			},
		});
	};
